import gql from "graphql-tag";

export const markAsVerifiedDilutionMutation = gql`
  mutation MarkAsVerified($id: ID!) {
    markAsVerified(id: $id) {
      id
    }
  }
`;
